export enum OrderPreviewPreparationStatusName {
	NEW = "NEW",
	IN_PROGRESS = "IN_PROGRESS",
	READY = "READY",
	PACKED = "PACKED",
	RECEIVED = "RECEIVED",
	DELIVERED = "DELIVERED",
	ACCEPTED = "ACCEPTED",
	IN_DELIVERY = "IN_DELIVERY",
}
